(function ($) {
    'use strict';

    var IconGridModule = {
        init: function () {
            this.$triggers = $('.js-icon-grid__trigger');
            this.bindEvents();
        },

        bindEvents: function () {
            var self = this;

            // Trigger button clicks
            this.$triggers.on('click', function () {
                var $trigger = $(this);
                self.handleToggle($trigger);
            });
        },

        handleToggle: function ($trigger) {
            var $hiddenContent = $trigger.siblings('.js-icon-grid__hidden-content');
            var $triggerText = $trigger.find('.m-icon_grid__triggertext');
            var $triggerIcon = $trigger.find('.m-icon_grid__triggericon');

            // Toggle the hidden content with slide animation
            $hiddenContent.slideToggle(300);

            // Toggle the active class for styling
            $trigger.toggleClass('active');

            // Update text based on current state
            if ($trigger.hasClass('active')) {
                $triggerText.text('Show less');
            } else {
                $triggerText.text('Learn more');
            }
        }
    };

    // Initialize on document ready
    $(function () {
        IconGridModule.init();
    });
})(jQuery);